import MessageAttachment, {
    IMAGE_HEIGHT_MAX,
} from 'flow/components/tickets/event-item/Messages/MessageAttachment';
import { TicketAttachment } from 'flow/types/TicketEventData';
import { TypedMap } from 'flow/types/TypedMap';

interface Props {
    attachment: TypedMap<TicketAttachment>;
    sentTime?: string;
}

const TicketMessageAttachment = ({ attachment, sentTime }: Props) => {
    return (
        <MessageAttachment
            fileName={attachment.get('fileName')}
            fileType={attachment.get('fileType')}
            fileSize={attachment.get('fileSize')}
            previewUrl={attachment.get('previewUrl')}
            url={attachment.get('url')}
            previewWidth={attachment.get('previewWidth')}
            previewHeight={attachment.get('previewHeight')}
            sentTime={sentTime}
        />
    );
};

export default TicketMessageAttachment;

interface EmailProps extends Props {
    htmlWidth?: number;
    htmlHeight?: number;
    interactive?: boolean;
}

export const EmailTicketMessageAttachment = ({
    attachment,
    sentTime,
    htmlWidth,
    htmlHeight,
    interactive = true,
}: EmailProps) => {
    const useHtmlDimensions =
        htmlWidth && htmlHeight && htmlHeight <= IMAGE_HEIGHT_MAX;

    return (
        <MessageAttachment
            fileName={attachment.get('fileName')}
            fileType={attachment.get('fileType')}
            fileSize={attachment.get('fileSize')}
            previewUrl={attachment.get('previewUrl')}
            url={attachment.get('url')}
            previewWidth={
                useHtmlDimensions ? htmlWidth : attachment.get('previewWidth')
            }
            previewHeight={
                useHtmlDimensions ? htmlHeight : attachment.get('previewHeight')
            }
            sentTime={sentTime}
            interactive={interactive}
        />
    );
};
